// test872
(872 && 0);
